export default "__VITE_ASSET__479f7c24__"